// extracted by mini-css-extract-plugin
module.exports = {"modelPartList":"az_n-","modelItem":"az_o-","modelItemContainer":"az_p-","modelLink":"az_q-","readMoreSmallProdDesc":"az_r-","showMoreButton":"az_s-","readMoreButton":"az_t-"};